export type LanguageCode = 'en' | 'or';

export interface LanguageOption {
  code: LanguageCode;
  label: string;
}

export type TranslationTable = Record<string, string>;

export const DEFAULT_LANGUAGE: LanguageCode = 'en';

export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: 'en', label: 'English' },
  { code: 'or', label: 'ଓଡ଼ିଆ' }
];

const en: TranslationTable = {
  'app.brand': 'Odisha Fire & Emergency Services',
  'app.name': 'Procurement Tracking System',
  'app.fullName': 'Odisha Fire & Emergency Services, Procurement Tracking System',
  'app.tagline': 'Local and LAN ready procurement lifecycle module',
  'app.language': 'Language',
  'app.signedInAs': 'Signed in as',
  'app.logout': 'Logout',
  'app.expandSidePanel': 'Expand side panel',
  'app.collapseSidePanel': 'Collapse side panel',
  'app.expand': 'Expand',
  'app.collapse': 'Collapse',

  'nav.main': 'Main',
  'nav.dashboard': 'Dashboard',
  'nav.procurementRegister': 'Procurement Register',
  'nav.procurementCaseRegister': 'Procurement Case Register',
  'nav.tenderingProcessTracker': 'Tendering Process Tracker',
  'nav.tools': 'Tools',
  'nav.summaryDashboard': 'Summary Dashboard',
  'nav.requisitionRegister': 'Requisition Register',
  'nav.financialManagement': 'Financial Management',
  'nav.gemProcurement': 'GeM Procurement',
  'nav.eTendering': 'e-Tendering',
  'nav.globalTender': 'Global Tender',
  'nav.lpc': 'LPC',
  'nav.openMarket': 'Open Market',
  'nav.otherProcurement': 'Other Procurement',
  'nav.tenderBidRegister': 'Tender/Bid Register',
  'nav.emdTracker': 'EMD Tracker/Register',
  'nav.sampleRegister': 'Sample Register',
  'nav.technicalEvaluation': 'Technical Evaluation',
  'nav.financialEvaluation': 'Financial Evaluation',
  'nav.purchaseOrder': 'Purchase Order',
  'nav.performanceSecurity': 'Performance Security',
  'nav.deliveryAcceptance': 'Delivery/Acceptance',
  'nav.paymentTracker': 'Payment Tracker',
  'nav.reports': 'Reports',
  'nav.userManagement': 'User Management',
  'nav.myProfile': 'My Profile',
  'nav.changeTheme': 'Change Theme',

  'login.username': 'Username',
  'login.password': 'Password',
  'login.showPassword': 'Show password',
  'login.hidePassword': 'Hide password',
  'login.signIn': 'Sign in',
  'login.signingIn': 'Signing in...',
  'login.help': 'Contact your administrator for login credentials.',
  'login.invalid': 'Invalid credentials or backend unavailable.',

  'common.actions': 'Actions',
  'common.cancel': 'Cancel',
  'common.active': 'Active',
  'common.addItem': 'Add Item',
  'common.addRecord': 'New Record',
  'common.allTime': 'All Time',
  'common.allTypes': 'All Types',
  'common.applyTheme': 'Apply Theme',
  'common.dateRange': 'Date Range',
  'common.delete': 'Delete',
  'common.deleteSelected': 'Delete Selected',
  'common.downloadExcel': 'Download Excel',
  'common.downloadPdf': 'Download PDF',
  'common.edit': 'Edit',
  'common.generateReport': 'Generate Report',
  'common.first': 'First',
  'common.last': 'Last',
  'common.modify': 'Modify',
  'common.month': 'Month',
  'common.monthYear': 'Month / Year',
  'common.next': 'Next',
  'common.no': 'No',
  'common.previous': 'Previous',
  'common.pagination': 'Pagination',
  'common.print': 'Print',
  'common.record': 'record',
  'common.records': 'records',
  'common.remove': 'Remove',
  'common.save': 'Save',
  'common.search': 'Search',
  'common.searchItem': 'Search item',
  'common.searchRecords': 'Search records',
  'common.select': 'Select',
  'common.selectItem': 'Select Item',
  'common.selected': 'Selected',
  'common.rowsPerPage': 'Rows per page',
  'common.showingRange': 'Showing {start}-{end} of {total}',
  'common.total': 'Total',
  'common.selectBudgetHead': 'Select budget head',
  'common.typeOrSelectBudgetHead': 'Type or select budget head',
  'common.typeOrSelectEstablishment': 'Type or select establishment',
  'common.typeOrSelectItem': 'Type or select item',
  'common.view': 'View',
  'common.viewRegister': 'View Register',
  'common.year': 'Year',
  'common.yearTotal': 'Year Total',
  'common.yes': 'Yes',
  'Clear': 'Clear',
  'Close': 'Close',
  'Create': 'Create',
  'Print': 'Print',
  'Update': 'Update',
  'Others': 'Others',
  'Manual Procurement Case': 'Manual Procurement Case',
  'Other Procurement Mode': 'Other Procurement Mode',
  'Enter procurement case number or reference': 'Enter procurement case number or reference',
  'Enter procurement mode': 'Enter procurement mode',
  'Alphanumeric and special characters are allowed.': 'Alphanumeric and special characters are allowed.',
  'Other Type': 'Other Type',
  'Budget Head Name': 'Budget Head Name',
  'Enter item description': 'Enter item description',
  'Enter item type': 'Enter item type',
  'Enter budget head name': 'Enter budget head name',
  'Letter No. / Requisition No.': 'Letter No. / Requisition No.',
  'Condemnable': 'Condemnable',
  'Not Condemnable': 'Not Condemnable',

  'lifecycle.itemDescription': 'Create, modify, select, and delete item records.',
  'lifecycle.recordDescription': 'Manage records with validation, search, pagination, and direct updates.',
  'lifecycle.requisitionReceivedFrom': 'Requisition Received From',
  'lifecycle.details': 'Details',
  'lifecycle.recordNo': 'Record #',
  'lifecycle.pageOf': 'Page {page} of {total}',
  'lifecycle.deleteConfirm': 'Delete {entity} #{id}?',
  'lifecycle.deleteSelectedConfirm': 'Delete {count} selected item{plural}?',
  'lifecycle.adminApprovalError': 'Administrative Approval Quantity cannot be higher than Requisition quantity.',
  'lifecycle.validationSummary': 'Please correct the highlighted fields before creating the requisition.',
  'validation.required': '{field} is required.',
  'validation.maxLength': '{field} cannot exceed {length} characters.',
  'validation.nonNegative': '{field} cannot be negative.',
  'validation.invalid': 'Enter a valid value for {field}.',
  'lifecycle.failedLoadRecords': 'Failed to load records.',
  'lifecycle.unableSaveRecord': 'Unable to save record.',
  'lifecycle.failedDeleteRecord': 'Failed to delete record.',
  'lifecycle.failedDeleteSelected': 'Failed to delete selected items.',

  'dashboard.title': 'Procurement Monitoring Dashboard',
  'dashboard.description': 'Module-wise entry counts, distributions and status bifurcation for Odisha Fire & Emergency Services.',
  'dashboard.refreshAll': 'Refresh All',
  'dashboard.totalEntries': 'Total Entries',
  'dashboard.entriesAcrossModules': 'Entries Across All Modules',
  'dashboard.entriesRecorded': 'Entries Recorded',
  'dashboard.sectionCards': 'Section Cards',
  'dashboard.moduleIndicators': 'Module-wise Indicators',
  'dashboard.moduleDescription': 'Every module can be reviewed separately by month and year, year total, or an exact date range.',
  'dashboard.cardFilters': 'Card filters',
  'dashboard.indicator1': 'Indicator 1',
  'dashboard.indicator2': 'Indicator 2',
  'dashboard.indicator3': 'Indicator 3',
  'dashboard.totalPrefix': 'No. of total',
  'dashboard.in': 'in',
  'dashboard.noData': 'No data available for this period.',
  'dashboard.noStatusData': 'No status data available for this period.',
  'dashboard.bifurcationPercent': 'Bifurcation (%)',
  'dashboard.recentActivity': 'Recent Activity',
  'dashboard.recentActivityDescription': 'Latest recorded movements across procurement modules.',
  'dashboard.updated': 'Updated',
  'reqDashboard.title': 'Requisition Dashboard',
  'reqDashboard.description': 'Live requisition indicators, approval movement, and budget-head value distribution.',
  'reqDashboard.selectedStatus': 'Selected Status',
  'reqDashboard.shareOfTotal': 'Share of Total',
  'reqDashboard.receivedInsightTitle': 'Requisition intake snapshot',
  'reqDashboard.receivedInsightText': 'This tile shows the complete volume received by the office and helps compare approvals, rejections, and pending movement.',
  'reqDashboard.approvedInsightTitle': 'Approved and ready for action',
  'reqDashboard.approvedInsightText': 'Approved requisitions have cleared scrutiny and can move into procurement planning or tendering workflows.',
  'reqDashboard.rejectedInsightTitle': 'Rejected requisitions need review',
  'reqDashboard.rejectedInsightText': 'Rejected records are useful for spotting missing documentation, unsuitable quantities, or repeated submission issues.',
  'reqDashboard.pendingInsightTitle': 'Pending requisitions need follow-up',
  'reqDashboard.pendingInsightText': 'Pending records are still in review. Use this count to monitor workload and reduce approval delay.',
  'reqDashboard.noStatusSelected': 'Select a status tile to view the indicator context.',
  'reqDashboard.budgetHeadAmounts': 'Budget Head-wise Amount of Requisitions',
  'reqDashboard.budgetHeadDescription': 'Select a budget head to inspect its requisition value and record count.',
  'reqDashboard.totalRequisitionValue': 'Total Requisition Value',
  'reqDashboard.budgetSelectionMessage': 'Selected budget head contribution to the requisition register.',
  'reqDashboard.recentDescription': 'Latest requisition activity for quick review before opening the register.',
  'Total Requisitions Received': 'Total Requisitions Received',
  'Approved Requisitions': 'Approved Requisitions',
  'Rejected Requisitions': 'Rejected Requisitions',
  'Pending Requisitions': 'Pending Requisitions',
  'All requisitions entered in the register.': 'All requisitions entered in the register.',
  'Requisitions cleared for procurement action.': 'Requisitions cleared for procurement action.',
  'Requisitions returned or rejected during scrutiny.': 'Requisitions returned or rejected during scrutiny.',
  'Requisitions still moving through review.': 'Requisitions still moving through review.',
  'Received From': 'Received From',
  'Estimated Cost': 'Estimated Cost',
  'Updated': 'Updated',
  'procTypeDashboard.title': 'Procurement Type Dashboards',
  'procTypeDashboard.description': 'Track every procurement type with bid dates, EMD movement, purchase orders, delivery and performance security status.',
  'procTypeDashboard.bidPublication': 'Bid Publication Date',
  'procTypeDashboard.submissionDate': 'Submission Date',
  'procTypeDashboard.emdStatus': 'EMD Status',
  'procTypeDashboard.bidStatus': 'Bid Status',
  'procTypeDashboard.purchaseOrder': 'Purchase Order',
  'procTypeDashboard.deliveryAcceptance': 'Delivery and Acceptance',
  'procTypeDashboard.performanceSecurity': 'Performance Security',
  'procTypeDashboard.bidPublicationMessage': 'Cases where a bid publication date is recorded.',
  'procTypeDashboard.submissionDateMessage': 'Cases where a bid submission or closing date is recorded.',
  'procTypeDashboard.communicationTitle': 'workflow signal',
  'procTypeDashboard.poPendingMessage': 'Some cases do not yet have purchase orders. Review award and PO issue steps.',
  'procTypeDashboard.emdPendingMessage': 'Some EMD-applicable cases still show EMD not submitted. Follow up before evaluation advances.',
  'procTypeDashboard.deliveryPendingMessage': 'Purchase activity exists, but delivery and acceptance records are not complete for every case.',
  'procTypeDashboard.healthyMessage': 'Core workflow checkpoints are recorded for this procurement type.',
  'Submitted': 'Submitted',
  'Not Submitted': 'Not Submitted',
  'Exempted': 'Exempted',
  'Published': 'Published',
  'In Evaluation': 'In Evaluation',
  'Closed': 'Closed',
  'Not Published': 'Not Published',
  'Issued': 'Issued',
  'Not Issued': 'Not Issued',
  'Not Recorded': 'Not Recorded',
  'Held': 'Held',
  'Released': 'Released',
  'approved': 'Approved',
  'rejected': 'Rejected',
  'In Tendering Process': 'In Tendering Process',
  'Re-Tendered': 'Re-Tendered',
  'Cancelled': 'Cancelled',
  'Procurement Case No': 'Procurement Case No',
  'dashboard.loadingIndicators': 'Loading module indicators...',
  'dashboard.unableLoadTotals': 'Unable to load dashboard entry totals.',
  'dashboard.selectDateRange': 'Select at least one date to apply the date range filter.',
  'dashboard.fromAfterTo': 'From Date cannot be later than To Date.',
  'dashboard.unableLoadIndicators': 'Unable to load indicators for this module.',

  'reports.title': 'Reports',
  'reports.description': 'Standardized procurement reports with branded PDF and Excel downloads.',
  'reports.reportingPeriod': 'Reporting Period',
  'reports.fromDate': 'From Date',
  'reports.toDate': 'To Date',
  'reports.preparing': 'Preparing report...',
  'reports.procurementCell': 'Procurement Cell',
  'reports.generatedOn': 'Generated On',
  'reports.noRecords': 'No records found for the selected reporting period.',
  'reports.failedGenerate': 'Failed to generate the selected report.',
  'reports.emptyDownload': 'Downloaded report was empty.',
  'reports.failedDownload': 'Failed to download {format} report.',
  'reports.selectRangeDate': 'Select at least one date for the date range report.',

  'users.title': 'User Administration',
  'users.description': 'Create role-based users for procurement, evaluation, finance, and read-only access.',
  'users.createUser': 'Create User',
  'users.fullName': 'Full Name',
  'users.email': 'Email',
  'users.name': 'Name',
  'users.role': 'Role',
  'users.unableCreate': 'Unable to create user.',
  'users.failedLoad': 'Failed to load users.',
  'users.resetCredentials': 'Reset User Credentials',
  'users.resetFor': 'Change the username or password for {{name}}.',
  'users.newPassword': 'New Password',
  'users.passwordOptional': 'Leave blank to keep the current password. Minimum 8 characters.',
  'users.saveCredentials': 'Save Credentials',
  'users.reset': 'Reset Login',
  'users.credentialsSaved': 'User credentials updated successfully.',
  'users.credentialsFailed': 'Unable to update user credentials.',
  'users.editAccess': 'Edit Role and Functionality Access',
  'users.editAccessFor': 'Manage role, account status, login, and module access for {{name}}.',
  'users.accountActive': 'Account active',
  'users.functionalityAccess': 'Functionality Access',
  'users.adminFullAccess': 'Administrators always have access to all functionality.',
  'users.saveAccess': 'Save User Access',
  'users.manageAccess': 'Manage Access',
  'profile.title': 'My Profile',
  'profile.description': 'Manage your account details and password.',
  'profile.details': 'Profile Details',
  'profile.save': 'Save Profile',
  'profile.saved': 'Profile updated successfully.',
  'profile.saveFailed': 'Unable to update profile.',
  'profile.changePassword': 'Change Password',
  'profile.passwordHint': 'Use at least 8 characters. Your current password is required.',
  'profile.currentPassword': 'Current Password',
  'profile.newPassword': 'New Password',
  'profile.confirmPassword': 'Confirm Password',
  'profile.updatePassword': 'Update Password',
  'profile.passwordMismatch': 'The new passwords do not match.',
  'profile.passwordChanged': 'Password changed successfully.',
  'profile.passwordFailed': 'Unable to change password.',
  'Current password is incorrect': 'Current password is incorrect.',
  'New password must be different from the current password': 'New password must be different from the current password.',

  'theme.title': 'Change Theme',
  'theme.description': 'Choose the application theme used for registers, dashboards, and reports.',

  'month.1': 'January',
  'month.2': 'February',
  'month.3': 'March',
  'month.4': 'April',
  'month.5': 'May',
  'month.6': 'June',
  'month.7': 'July',
  'month.8': 'August',
  'month.9': 'September',
  'month.10': 'October',
  'month.11': 'November',
  'month.12': 'December'
};

const or: TranslationTable = {
  'app.brand': 'ଓଡ଼ିଶା ଅଗ୍ନିଶମ ଏବଂ ଜରୁରୀ ସେବା',
  'app.name': 'କ୍ରୟ ଟ୍ରାକିଂ ସିଷ୍ଟମ',
  'app.fullName': 'ଓଡ଼ିଶା ଅଗ୍ନିଶମ ଏବଂ ଜରୁରୀ ସେବା, କ୍ରୟ ଟ୍ରାକିଂ ସିଷ୍ଟମ',
  'app.tagline': 'ସ୍ଥାନୀୟ ଏବଂ LAN ପାଇଁ ପ୍ରସ୍ତୁତ କ୍ରୟ ଜୀବନଚକ୍ର ମଡ୍ୟୁଲ',
  'app.language': 'ଭାଷା',
  'app.signedInAs': 'ଲଗଇନ କରିଛନ୍ତି',
  'app.logout': 'ଲଗଆଉଟ',
  'app.expandSidePanel': 'ପାର୍ଶ୍ୱ ପ୍ୟାନେଲ ବିସ୍ତାର କରନ୍ତୁ',
  'app.collapseSidePanel': 'ପାର୍ଶ୍ୱ ପ୍ୟାନେଲ ସଂକୁଚିତ କରନ୍ତୁ',
  'app.expand': 'ବିସ୍ତାର',
  'app.collapse': 'ସଂକୁଚିତ',

  'nav.main': 'ମୁଖ୍ୟ',
  'nav.dashboard': 'ଡ୍ୟାଶବୋର୍ଡ',
  'nav.procurementRegister': 'କ୍ରୟ ରେଜିଷ୍ଟର',
  'nav.procurementCaseRegister': 'କ୍ରୟ ମାମଲା ରେଜିଷ୍ଟର',
  'nav.tenderingProcessTracker': 'ଟେଣ୍ଡରିଂ ପ୍ରକ୍ରିୟା ଟ୍ରାକର',
  'nav.tools': 'ଉପକରଣ',
  'nav.summaryDashboard': 'ସାରାଂଶ ଡ୍ୟାଶବୋର୍ଡ',
  'nav.requisitionRegister': 'ଆବଶ୍ୟକତା ରେଜିଷ୍ଟର',
  'nav.financialManagement': 'ଆର୍ଥିକ ପରିଚାଳନା',
  'nav.gemProcurement': 'GeM କ୍ରୟ',
  'nav.eTendering': 'ଇ-ଟେଣ୍ଡରିଂ',
  'nav.globalTender': 'ଗ୍ଲୋବାଲ ଟେଣ୍ଡର',
  'nav.lpc': 'LPC',
  'nav.openMarket': 'ଖୋଲା ବଜାର',
  'nav.otherProcurement': 'ଅନ୍ୟାନ୍ୟ କ୍ରୟ',
  'nav.tenderBidRegister': 'ଟେଣ୍ଡର/ବିଡ୍ ରେଜିଷ୍ଟର',
  'nav.emdTracker': 'EMD ଟ୍ରାକର/ରେଜିଷ୍ଟର',
  'nav.sampleRegister': 'ନମୁନା ରେଜିଷ୍ଟର',
  'nav.technicalEvaluation': 'ପ୍ରାଯୁକ୍ତିକ ମୂଲ୍ୟାୟନ',
  'nav.financialEvaluation': 'ଆର୍ଥିକ ମୂଲ୍ୟାୟନ',
  'nav.purchaseOrder': 'କ୍ରୟ ଆଦେଶ',
  'nav.performanceSecurity': 'କାର୍ଯ୍ୟଦକ୍ଷତା ସୁରକ୍ଷା',
  'nav.deliveryAcceptance': 'ଡେଲିଭରି/ଗ୍ରହଣ',
  'nav.paymentTracker': 'ପେମେଣ୍ଟ ଟ୍ରାକର',
  'nav.reports': 'ରିପୋର୍ଟ',
  'nav.userManagement': 'ବ୍ୟବହାରକାରୀ ପରିଚାଳନା',
  'nav.myProfile': 'ମୋ ପ୍ରୋଫାଇଲ୍',
  'nav.changeTheme': 'ଥିମ୍ ପରିବର୍ତ୍ତନ',

  'login.username': 'ବ୍ୟବହାରକାରୀ ନାମ',
  'login.password': 'ପାସୱାର୍ଡ',
  'login.showPassword': 'ପାସୱାର୍ଡ ଦେଖନ୍ତୁ',
  'login.hidePassword': 'ପାସୱାର୍ଡ ଲୁଚାନ୍ତୁ',
  'login.signIn': 'ସାଇନ୍ ଇନ୍',
  'login.signingIn': 'ସାଇନ୍ ଇନ୍ ହେଉଛି...',
  'login.help': 'ଲଗଇନ ସୂଚନା ପାଇଁ ଆପଣଙ୍କ ଆଡମିନିଷ୍ଟ୍ରେଟରଙ୍କୁ ଯୋଗାଯୋଗ କରନ୍ତୁ।',
  'login.invalid': 'ଭୁଲ ଲଗଇନ ସୂଚନା କିମ୍ବା ବ୍ୟାକେଣ୍ଡ ଉପଲବ୍ଧ ନାହିଁ।',

  'common.actions': 'କାର୍ଯ୍ୟ',
  'common.cancel': 'ବାତିଲ୍',
  'common.active': 'ସକ୍ରିୟ',
  'common.addItem': 'ଆଇଟମ ଯୋଡନ୍ତୁ',
  'common.addRecord': 'ନୂଆ ରେକର୍ଡ',
  'common.allTime': 'ସମସ୍ତ ସମୟ',
  'common.allTypes': 'ସମସ୍ତ ପ୍ରକାର',
  'common.applyTheme': 'ଥିମ୍ ପ୍ରୟୋଗ କରନ୍ତୁ',
  'common.dateRange': 'ତାରିଖ ସୀମା',
  'common.delete': 'ଡିଲିଟ୍',
  'common.deleteSelected': 'ଚୟନିତ ଡିଲିଟ୍',
  'common.downloadExcel': 'Excel ଡାଉନଲୋଡ୍',
  'common.downloadPdf': 'PDF ଡାଉନଲୋଡ୍',
  'common.edit': 'ସମ୍ପାଦନ',
  'common.generateReport': 'ରିପୋର୍ଟ ସୃଷ୍ଟି କରନ୍ତୁ',
  'common.first': 'ପ୍ରଥମ',
  'common.last': 'ଶେଷ',
  'common.modify': 'ପରିବର୍ତ୍ତନ',
  'common.month': 'ମାସ',
  'common.monthYear': 'ମାସ / ବର୍ଷ',
  'common.next': 'ପରବର୍ତ୍ତୀ',
  'common.no': 'ନା',
  'common.previous': 'ପୂର୍ବବର୍ତ୍ତୀ',
  'common.pagination': 'ପୃଷ୍ଠାକରଣ',
  'common.print': 'ପ୍ରିଣ୍ଟ',
  'common.record': 'ରେକର୍ଡ',
  'common.records': 'ରେକର୍ଡଗୁଡ଼ିକ',
  'common.remove': 'ହଟାନ୍ତୁ',
  'common.save': 'ସଞ୍ଚୟ',
  'common.search': 'ସନ୍ଧାନ',
  'common.searchItem': 'ଆଇଟମ ସନ୍ଧାନ',
  'common.searchRecords': 'ରେକର୍ଡ ସନ୍ଧାନ',
  'common.select': 'ଚୟନ',
  'common.selectItem': 'ଆଇଟମ ଚୟନ',
  'common.selected': 'ଚୟନିତ',
  'common.rowsPerPage': 'ପ୍ରତି ପୃଷ୍ଠାରେ ଧାଡି',
  'common.showingRange': '{total} ମଧ୍ୟରୁ {start}-{end} ଦେଖାଯାଉଛି',
  'common.total': 'ମୋଟ',
  'common.typeOrSelectEstablishment': 'ସ୍ଥାପନା ଟାଇପ୍ କିମ୍ବା ଚୟନ କରନ୍ତୁ',
  'common.typeOrSelectItem': 'ଆଇଟମ ଟାଇପ୍ କିମ୍ବା ଚୟନ କରନ୍ତୁ',
  'common.view': 'ଦେଖନ୍ତୁ',
  'common.viewRegister': 'ରେଜିଷ୍ଟର ଦେଖନ୍ତୁ',
  'common.year': 'ବର୍ଷ',
  'common.yearTotal': 'ବର୍ଷ ସମୁଦାୟ',
  'common.yes': 'ହଁ',
  'Clear': 'ସଫା କରନ୍ତୁ',
  'Close': 'ବନ୍ଦ କରନ୍ତୁ',
  'Create': 'ସୃଷ୍ଟି',
  'Print': 'ପ୍ରିଣ୍ଟ',
  'Update': 'ଅପଡେଟ୍',

  'lifecycle.itemDescription': 'ଆଇଟମ ରେକର୍ଡ ସୃଷ୍ଟି, ପରିବର୍ତ୍ତନ, ଚୟନ ଏବଂ ଡିଲିଟ୍ କରନ୍ତୁ।',
  'lifecycle.recordDescription': 'ଭ୍ୟାଲିଡେସନ୍, ସନ୍ଧାନ, ପୃଷ୍ଠାକରଣ ଏବଂ ସିଧାସଳଖ ଅପଡେଟ୍ ସହ ରେକର୍ଡ ପରିଚାଳନା କରନ୍ତୁ।',
  'lifecycle.requisitionReceivedFrom': 'ଆବଶ୍ୟକତା ଗ୍ରହଣ ହୋଇଛି',
  'lifecycle.details': 'ବିବରଣୀ',
  'lifecycle.recordNo': 'ରେକର୍ଡ #',
  'lifecycle.pageOf': 'ପୃଷ୍ଠା {page} / {total}',
  'lifecycle.deleteConfirm': '{entity} #{id} ଡିଲିଟ୍ କରିବେ?',
  'lifecycle.deleteSelectedConfirm': '{count} ଚୟନିତ ଆଇଟମ ଡିଲିଟ୍ କରିବେ?',
  'lifecycle.adminApprovalError': 'ପ୍ରଶାସନିକ ଅନୁମୋଦନ ପରିମାଣ ଆବଶ୍ୟକତା ପରିମାଣଠାରୁ ଅଧିକ ହୋଇପାରିବ ନାହିଁ।',
  'lifecycle.validationSummary': 'ଆବଶ୍ୟକତା ସୃଷ୍ଟି କରିବା ପୂର୍ବରୁ ଲାଲ ରଙ୍ଗରେ ଦର୍ଶାଯାଇଥିବା ଫିଲ୍ଡଗୁଡ଼ିକୁ ସଠିକ୍ କରନ୍ତୁ।',
  'validation.required': '{field} ଆବଶ୍ୟକ।',
  'validation.maxLength': '{field} {length} ଅକ୍ଷରରୁ ଅଧିକ ହୋଇପାରିବ ନାହିଁ।',
  'validation.nonNegative': '{field} ଋଣାତ୍ମକ ହୋଇପାରିବ ନାହିଁ।',
  'validation.invalid': '{field} ପାଇଁ ଏକ ବୈଧ ମୂଲ୍ୟ ଲେଖନ୍ତୁ।',
  'lifecycle.failedLoadRecords': 'ରେକର୍ଡ ଲୋଡ୍ କରିବାରେ ବିଫଳ।',
  'lifecycle.unableSaveRecord': 'ରେକର୍ଡ ସଞ୍ଚୟ କରିପାରିଲା ନାହିଁ।',
  'lifecycle.failedDeleteRecord': 'ରେକର୍ଡ ଡିଲିଟ୍ କରିବାରେ ବିଫଳ।',
  'lifecycle.failedDeleteSelected': 'ଚୟନିତ ଆଇଟମ ଡିଲିଟ୍ କରିବାରେ ବିଫଳ।',

  'dashboard.title': 'କ୍ରୟ ନିରୀକ୍ଷଣ ଡ୍ୟାଶବୋର୍ଡ',
  'dashboard.description': 'ଓଡ଼ିଶା ଅଗ୍ନିଶମ ଏବଂ ଜରୁରୀ ସେବା ପାଇଁ ମଡ୍ୟୁଲ ଅନୁଯାୟୀ ଏଣ୍ଟ୍ରି ଗଣନା, ବିତରଣ ଏବଂ ସ୍ଥିତି ବିଭାଜନ।',
  'dashboard.refreshAll': 'ସବୁ ରିଫ୍ରେଶ୍',
  'dashboard.totalEntries': 'ମୋଟ ଏଣ୍ଟ୍ରି',
  'dashboard.entriesAcrossModules': 'ସମସ୍ତ ମଡ୍ୟୁଲରେ ଏଣ୍ଟ୍ରି',
  'dashboard.entriesRecorded': 'ରେକର୍ଡ ହୋଇଥିବା ଏଣ୍ଟ୍ରି',
  'dashboard.sectionCards': 'ସେକ୍ସନ କାର୍ଡ',
  'dashboard.moduleIndicators': 'ମଡ୍ୟୁଲ ଅନୁଯାୟୀ ସୂଚକ',
  'dashboard.moduleDescription': 'ପ୍ରତ୍ୟେକ ମଡ୍ୟୁଲକୁ ମାସ/ବର୍ଷ, ବର୍ଷ ସମୁଦାୟ କିମ୍ବା ନିର୍ଦ୍ଦିଷ୍ଟ ତାରିଖ ସୀମା ଅନୁଯାୟୀ ଦେଖାଯାଇପାରିବ।',
  'dashboard.cardFilters': 'କାର୍ଡ ଫିଲ୍ଟର',
  'dashboard.indicator1': 'ସୂଚକ ୧',
  'dashboard.indicator2': 'ସୂଚକ ୨',
  'dashboard.indicator3': 'ସୂଚକ ୩',
  'dashboard.totalPrefix': 'ମୋଟ ସଂଖ୍ୟା',
  'dashboard.in': 'ଭିତରେ',
  'dashboard.noData': 'ଏହି ସମୟ ପାଇଁ କୌଣସି ତଥ୍ୟ ନାହିଁ।',
  'dashboard.noStatusData': 'ଏହି ସମୟ ପାଇଁ ସ୍ଥିତି ତଥ୍ୟ ନାହିଁ।',
  'dashboard.bifurcationPercent': 'ବିଭାଜନ (%)',
  'dashboard.recentActivity': 'ସମ୍ପ୍ରତି କାର୍ଯ୍ୟକଳାପ',
  'dashboard.recentActivityDescription': 'କ୍ରୟ ମଡ୍ୟୁଲଗୁଡ଼ିକରେ ଶେଷ ରେକର୍ଡ ଗତିବିଧି।',
  'dashboard.updated': 'ଅପଡେଟ୍',
  'dashboard.loadingIndicators': 'ମଡ୍ୟୁଲ ସୂଚକ ଲୋଡ୍ ହେଉଛି...',
  'dashboard.unableLoadTotals': 'ଡ୍ୟାଶବୋର୍ଡ ଏଣ୍ଟ୍ରି ସମୁଦାୟ ଲୋଡ୍ କରିପାରିଲା ନାହିଁ।',
  'dashboard.selectDateRange': 'ତାରିଖ ସୀମା ଫିଲ୍ଟର ପାଇଁ କମ୍ ସେ କମ୍ ଗୋଟିଏ ତାରିଖ ଚୟନ କରନ୍ତୁ।',
  'dashboard.fromAfterTo': 'From Date, To Date ପରେ ହୋଇପାରିବ ନାହିଁ।',
  'dashboard.unableLoadIndicators': 'ଏହି ମଡ୍ୟୁଲ ପାଇଁ ସୂଚକ ଲୋଡ୍ କରିପାରିଲା ନାହିଁ।',

  'reqDashboard.title': 'ଆବଶ୍ୟକତା ଡ୍ୟାଶବୋର୍ଡ',
  'reqDashboard.description': 'ଆବଶ୍ୟକତା ସୂଚକ, ଅନୁମୋଦନ ଗତିବିଧି ଏବଂ ବଜେଟ୍ ହେଡ୍ ଅନୁଯାୟୀ ମୂଲ୍ୟ ବିତରଣ।',
  'reqDashboard.selectedStatus': 'ଚୟନିତ ସ୍ଥିତି',
  'reqDashboard.shareOfTotal': 'ମୋଟର ଅଂଶ',
  'reqDashboard.receivedInsightTitle': 'ଆବଶ୍ୟକତା ଗ୍ରହଣ ସାରାଂଶ',
  'reqDashboard.receivedInsightText': 'ଏହି ଟାଇଲ୍ ଅଫିସରେ ଗ୍ରହଣ ହୋଇଥିବା ସମ୍ପୂର୍ଣ୍ଣ ପରିମାଣ ଦେଖାଏ ଏବଂ ଅନୁମୋଦନ, ପ୍ରତ୍ୟାଖ୍ୟାନ ଓ ବାକି ଗତିବିଧି ତୁଳନାରେ ସାହାଯ୍ୟ କରେ।',
  'reqDashboard.approvedInsightTitle': 'ଅନୁମୋଦିତ ଏବଂ କାର୍ଯ୍ୟ ପାଇଁ ପ୍ରସ୍ତୁତ',
  'reqDashboard.approvedInsightText': 'ଅନୁମୋଦିତ ଆବଶ୍ୟକତାଗୁଡିକ ଯାଞ୍ଚ ପରେ କ୍ରୟ ଯୋଜନା କିମ୍ବା ଟେଣ୍ଡରିଂ କାର୍ଯ୍ୟପ୍ରବାହକୁ ଯାଇପାରିବ।',
  'reqDashboard.rejectedInsightTitle': 'ପ୍ରତ୍ୟାଖ୍ୟାନ ହୋଇଥିବା ଆବଶ୍ୟକତା ପୁନଃସମୀକ୍ଷା ଆବଶ୍ୟକ',
  'reqDashboard.rejectedInsightText': 'ପ୍ରତ୍ୟାଖ୍ୟାନ ରେକର୍ଡ ଦ୍ୱାରା ଅନୁପସ୍ଥିତ ଦଲିଲ, ଅନୁଚିତ ପରିମାଣ କିମ୍ବା ପୁନରାବୃତ୍ତ ଦାଖଲ ସମସ୍ୟା ଚିହ୍ନଟ କରିହେବ।',
  'reqDashboard.pendingInsightTitle': 'ବାକି ଥିବା ଆବଶ୍ୟକତାରେ ଅନୁସରଣ ଆବଶ୍ୟକ',
  'reqDashboard.pendingInsightText': 'ବାକି ରେକର୍ଡଗୁଡିକ ଏବେ ମଧ୍ୟ ଯାଞ୍ଚରେ ଅଛି। କାମର ଭାର ଓ ଅନୁମୋଦନ ବିଳମ୍ବ କମାଇବା ପାଇଁ ଏହି ଗଣନା ବ୍ୟବହାର କରନ୍ତୁ।',
  'reqDashboard.noStatusSelected': 'ସୂଚକ ବିବରଣୀ ଦେଖିବା ପାଇଁ ଏକ ସ୍ଥିତି ଟାଇଲ୍ ଚୟନ କରନ୍ତୁ।',
  'reqDashboard.budgetHeadAmounts': 'ବଜେଟ୍ ହେଡ୍ ଅନୁଯାୟୀ ଆବଶ୍ୟକତା ରାଶି',
  'reqDashboard.budgetHeadDescription': 'ବଜେଟ୍ ହେଡ୍ ଚୟନ କରି ତାହାର ଆବଶ୍ୟକତା ମୂଲ୍ୟ ଓ ରେକର୍ଡ ଗଣନା ଦେଖନ୍ତୁ।',
  'reqDashboard.totalRequisitionValue': 'ମୋଟ ଆବଶ୍ୟକତା ମୂଲ୍ୟ',
  'reqDashboard.budgetSelectionMessage': 'ଆବଶ୍ୟକତା ରେଜିଷ୍ଟରରେ ଚୟନିତ ବଜେଟ୍ ହେଡ୍ ଅବଦାନ।',
  'reqDashboard.recentDescription': 'ରେଜିଷ୍ଟର ଖୋଲିବା ପୂର୍ବରୁ ଶୀଘ୍ର ସମୀକ୍ଷା ପାଇଁ ସମ୍ପ୍ରତି ଆବଶ୍ୟକତା କାର୍ଯ୍ୟକଳାପ।',
  'Total Requisitions Received': 'ମୋଟ ଗ୍ରହଣ ହୋଇଥିବା ଆବଶ୍ୟକତା',
  'Approved Requisitions': 'ଅନୁମୋଦିତ ଆବଶ୍ୟକତା',
  'Rejected Requisitions': 'ପ୍ରତ୍ୟାଖ୍ୟାନ ହୋଇଥିବା ଆବଶ୍ୟକତା',
  'Pending Requisitions': 'ବାକି ଥିବା ଆବଶ୍ୟକତା',
  'All requisitions entered in the register.': 'ରେଜିଷ୍ଟରରେ ଭର୍ତ୍ତି ହୋଇଥିବା ସମସ୍ତ ଆବଶ୍ୟକତା।',
  'Requisitions cleared for procurement action.': 'କ୍ରୟ କାର୍ଯ୍ୟ ପାଇଁ ଅନୁମୋଦିତ ଆବଶ୍ୟକତା।',
  'Requisitions returned or rejected during scrutiny.': 'ଯାଞ୍ଚ ସମୟରେ ଫେରାଇ ଦିଆଯାଇଥିବା କିମ୍ବା ପ୍ରତ୍ୟାଖ୍ୟାନ ଆବଶ୍ୟକତା।',
  'Requisitions still moving through review.': 'ଏବେ ମଧ୍ୟ ସମୀକ୍ଷାରେ ଥିବା ଆବଶ୍ୟକତା।',
  'Received From': 'ଗ୍ରହଣ ସ୍ଥାନ',
  'Updated': 'ଅଦ୍ୟତନ',
  'procTypeDashboard.title': 'ପ୍ରତ୍ୟେକ କ୍ରୟ ପ୍ରକାର ଡ୍ୟାଶବୋର୍ଡ',
  'procTypeDashboard.description': 'ବିଡ୍ ତାରିଖ, EMD ଗତିବିଧି, କ୍ରୟ ଆଦେଶ, ଡେଲିଭରି ଓ କାର୍ଯ୍ୟଦକ୍ଷତା ସୁରକ୍ଷା ସ୍ଥିତି ସହ ପ୍ରତ୍ୟେକ କ୍ରୟ ପ୍ରକାରକୁ ଟ୍ରାକ୍ କରନ୍ତୁ।',
  'procTypeDashboard.bidPublication': 'ବିଡ୍ ପ୍ରକାଶନ ତାରିଖ',
  'procTypeDashboard.submissionDate': 'ଦାଖଲ ତାରିଖ',
  'procTypeDashboard.emdStatus': 'EMD ସ୍ଥିତି',
  'procTypeDashboard.bidStatus': 'ବିଡ୍ ସ୍ଥିତି',
  'procTypeDashboard.purchaseOrder': 'କ୍ରୟ ଆଦେଶ',
  'procTypeDashboard.deliveryAcceptance': 'ଡେଲିଭରି ଏବଂ ଗ୍ରହଣ',
  'procTypeDashboard.performanceSecurity': 'କାର୍ଯ୍ୟଦକ୍ଷତା ସୁରକ୍ଷା',
  'procTypeDashboard.bidPublicationMessage': 'ଯେଉଁ କେସଗୁଡିକରେ ବିଡ୍ ପ୍ରକାଶନ ତାରିଖ ରେକର୍ଡ ହୋଇଛି।',
  'procTypeDashboard.submissionDateMessage': 'ଯେଉଁ କେସଗୁଡିକରେ ବିଡ୍ ଦାଖଲ କିମ୍ବା ବନ୍ଦ ତାରିଖ ରେକର୍ଡ ହୋଇଛି।',
  'procTypeDashboard.communicationTitle': 'କାର୍ଯ୍ୟପ୍ରବାହ ସଙ୍କେତ',
  'procTypeDashboard.poPendingMessage': 'କିଛି କେସରେ ଏପର୍ଯ୍ୟନ୍ତ କ୍ରୟ ଆଦେଶ ଜାରି ହୋଇନାହିଁ। ଅୱାର୍ଡ ଏବଂ PO ଜାରି ପଦକ୍ଷେପ ସମୀକ୍ଷା କରନ୍ତୁ।',
  'procTypeDashboard.emdPendingMessage': 'କିଛି EMD ଲାଗୁ ହୋଇଥିବା କେସରେ EMD ଦାଖଲ ହୋଇନାହିଁ। ମୂଲ୍ୟାୟନ ଆଗକୁ ବଢିବା ପୂର୍ବରୁ ଅନୁସରଣ କରନ୍ତୁ।',
  'procTypeDashboard.deliveryPendingMessage': 'କ୍ରୟ କାର୍ଯ୍ୟ ରହିଛି, କିନ୍ତୁ ସମସ୍ତ କେସ ପାଇଁ ଡେଲିଭରି ଏବଂ ଗ୍ରହଣ ରେକର୍ଡ ସମ୍ପୂର୍ଣ୍ଣ ନୁହେଁ।',
  'procTypeDashboard.healthyMessage': 'ଏହି କ୍ରୟ ପ୍ରକାର ପାଇଁ ମୁଖ୍ୟ କାର୍ଯ୍ୟପ୍ରବାହ ଚେକପଏଣ୍ଟ ରେକର୍ଡ ହୋଇଛି।',
  'Submitted': 'ଦାଖଲ',
  'Not Submitted': 'ଦାଖଲ ହୋଇନାହିଁ',
  'Exempted': 'ଛାଡ଼',
  'Published': 'ପ୍ରକାଶିତ',
  'In Evaluation': 'ମୂଲ୍ୟାୟନରେ',
  'Not Published': 'ପ୍ରକାଶିତ ହୋଇନାହିଁ',
  'Issued': 'ଜାରି',
  'Not Issued': 'ଜାରି ହୋଇନାହିଁ',
  'Not Recorded': 'ରେକର୍ଡ ହୋଇନାହିଁ',
  'Released': 'ମୁକ୍ତ',

  'reports.title': 'ରିପୋର୍ଟ',
  'reports.description': 'ବ୍ରାଣ୍ଡେଡ୍ PDF ଏବଂ Excel ଡାଉନଲୋଡ୍ ସହ ମାନକ କ୍ରୟ ରିପୋର୍ଟ।',
  'reports.reportingPeriod': 'ରିପୋର୍ଟିଂ ସମୟ',
  'reports.fromDate': 'ଆରମ୍ଭ ତାରିଖ',
  'reports.toDate': 'ଶେଷ ତାରିଖ',
  'reports.preparing': 'ରିପୋର୍ଟ ପ୍ରସ୍ତୁତ ହେଉଛି...',
  'reports.procurementCell': 'କ୍ରୟ ସେଲ୍',
  'reports.generatedOn': 'ସୃଷ୍ଟି ହୋଇଛି',
  'reports.noRecords': 'ଚୟନିତ ରିପୋର୍ଟିଂ ସମୟ ପାଇଁ କୌଣସି ରେକର୍ଡ ମିଳିଲା ନାହିଁ।',
  'reports.failedGenerate': 'ଚୟନିତ ରିପୋର୍ଟ ସୃଷ୍ଟି କରିବାରେ ବିଫଳ।',
  'reports.emptyDownload': 'ଡାଉନଲୋଡ୍ ହୋଇଥିବା ରିପୋର୍ଟ ଖାଲି ଥିଲା।',
  'reports.failedDownload': '{format} ରିପୋର୍ଟ ଡାଉନଲୋଡ୍ କରିବାରେ ବିଫଳ।',
  'reports.selectRangeDate': 'ତାରିଖ ସୀମା ରିପୋର୍ଟ ପାଇଁ କମ୍ ସେ କମ୍ ଗୋଟିଏ ତାରିଖ ଚୟନ କରନ୍ତୁ।',

  'users.title': 'ବ୍ୟବହାରକାରୀ ପ୍ରଶାସନ',
  'users.description': 'କ୍ରୟ, ମୂଲ୍ୟାୟନ, ଅର୍ଥ ଏବଂ କେବଳ ପଢିବା ଅଧିକାର ପାଇଁ ଭୂମିକା ଆଧାରିତ ବ୍ୟବହାରକାରୀ ସୃଷ୍ଟି କରନ୍ତୁ।',
  'users.createUser': 'ବ୍ୟବହାରକାରୀ ସୃଷ୍ଟି',
  'users.fullName': 'ପୂର୍ଣ୍ଣ ନାମ',
  'users.email': 'ଇମେଲ୍',
  'users.name': 'ନାମ',
  'users.role': 'ଭୂମିକା',
  'users.unableCreate': 'ବ୍ୟବହାରକାରୀ ସୃଷ୍ଟି କରିପାରିଲା ନାହିଁ।',
  'users.failedLoad': 'ବ୍ୟବହାରକାରୀ ଲୋଡ୍ କରିବାରେ ବିଫଳ।',
  'users.resetCredentials': 'ବ୍ୟବହାରକାରୀ ଲଗଇନ୍ ପୁନଃସେଟ୍',
  'users.resetFor': '{{name}}ଙ୍କ ବ୍ୟବହାରକାରୀ ନାମ କିମ୍ବା ପାସୱାର୍ଡ ପରିବର୍ତ୍ତନ କରନ୍ତୁ।',
  'users.newPassword': 'ନୂତନ ପାସୱାର୍ଡ',
  'users.passwordOptional': 'ବର୍ତ୍ତମାନର ପାସୱାର୍ଡ ରଖିବାକୁ ଖାଲି ଛାଡନ୍ତୁ। ସର୍ବନିମ୍ନ ୮ ଅକ୍ଷର।',
  'users.saveCredentials': 'ଲଗଇନ୍ ସଂରକ୍ଷଣ',
  'users.reset': 'ଲଗଇନ୍ ପୁନଃସେଟ୍',
  'users.credentialsSaved': 'ବ୍ୟବହାରକାରୀ ଲଗଇନ୍ ସଫଳତାର ସହ ଅଦ୍ୟତନ ହୋଇଛି।',
  'users.credentialsFailed': 'ବ୍ୟବହାରକାରୀ ଲଗଇନ୍ ଅଦ୍ୟତନ କରିହେଲା ନାହିଁ।',
  'users.editAccess': 'ଭୂମିକା ଏବଂ କାର୍ଯ୍ୟ ଅଧିକାର ସମ୍ପାଦନ',
  'users.editAccessFor': '{{name}}ଙ୍କ ଭୂମିକା, ଆକାଉଣ୍ଟ ସ୍ଥିତି, ଲଗଇନ୍ ଏବଂ ମଡ୍ୟୁଲ୍ ଅଧିକାର ପରିଚାଳନା କରନ୍ତୁ।',
  'users.accountActive': 'ଆକାଉଣ୍ଟ ସକ୍ରିୟ',
  'users.functionalityAccess': 'କାର୍ଯ୍ୟ ଅଧିକାର',
  'users.adminFullAccess': 'ପ୍ରଶାସକମାନଙ୍କ ପାଖରେ ସମସ୍ତ କାର୍ଯ୍ୟର ଅଧିକାର ସଦା ରହିବ।',
  'users.saveAccess': 'ବ୍ୟବହାରକାରୀ ଅଧିକାର ସଂରକ୍ଷଣ',
  'users.manageAccess': 'ଅଧିକାର ପରିଚାଳନା',
  'profile.title': 'ମୋ ପ୍ରୋଫାଇଲ୍',
  'profile.description': 'ଆପଣଙ୍କ ଆକାଉଣ୍ଟ ବିବରଣୀ ଏବଂ ପାସୱାର୍ଡ ପରିଚାଳନା କରନ୍ତୁ।',
  'profile.details': 'ପ୍ରୋଫାଇଲ୍ ବିବରଣୀ',
  'profile.save': 'ପ୍ରୋଫାଇଲ୍ ସଂରକ୍ଷଣ',
  'profile.saved': 'ପ୍ରୋଫାଇଲ୍ ସଫଳତାର ସହ ଅଦ୍ୟତନ ହୋଇଛି।',
  'profile.saveFailed': 'ପ୍ରୋଫାଇଲ୍ ଅଦ୍ୟତନ କରିହେଲା ନାହିଁ।',
  'profile.changePassword': 'ପାସୱାର୍ଡ ପରିବର୍ତ୍ତନ',
  'profile.passwordHint': 'ସର୍ବନିମ୍ନ ୮ ଅକ୍ଷର ବ୍ୟବହାର କରନ୍ତୁ। ବର୍ତ୍ତମାନର ପାସୱାର୍ଡ ଆବଶ୍ୟକ।',
  'profile.currentPassword': 'ବର୍ତ୍ତମାନର ପାସୱାର୍ଡ',
  'profile.newPassword': 'ନୂତନ ପାସୱାର୍ଡ',
  'profile.confirmPassword': 'ପାସୱାର୍ଡ ନିଶ୍ଚିତ କରନ୍ତୁ',
  'profile.updatePassword': 'ପାସୱାର୍ଡ ଅଦ୍ୟତନ',
  'profile.passwordMismatch': 'ନୂତନ ପାସୱାର୍ଡ ଦୁଇଟି ମେଳ ଖାଉନାହିଁ।',
  'profile.passwordChanged': 'ପାସୱାର୍ଡ ସଫଳତାର ସହ ପରିବର୍ତ୍ତନ ହୋଇଛି।',
  'profile.passwordFailed': 'ପାସୱାର୍ଡ ପରିବର୍ତ୍ତନ କରିହେଲା ନାହିଁ।',
  'Current password is incorrect': 'ବର୍ତ୍ତମାନର ପାସୱାର୍ଡ ଭୁଲ ଅଟେ।',
  'New password must be different from the current password': 'ନୂତନ ପାସୱାର୍ଡ ବର୍ତ୍ତମାନର ପାସୱାର୍ଡଠାରୁ ଭିନ୍ନ ହେବା ଆବଶ୍ୟକ।',

  'theme.title': 'ଥିମ୍ ପରିବର୍ତ୍ତନ',
  'theme.description': 'ରେଜିଷ୍ଟର, ଡ୍ୟାଶବୋର୍ଡ ଏବଂ ରିପୋର୍ଟ ପାଇଁ ଆପ୍ଲିକେସନ୍ ଥିମ୍ ଚୟନ କରନ୍ତୁ।',

  'month.1': 'ଜାନୁଆରୀ',
  'month.2': 'ଫେବ୍ରୁଆରୀ',
  'month.3': 'ମାର୍ଚ୍ଚ',
  'month.4': 'ଏପ୍ରିଲ୍',
  'month.5': 'ମେ',
  'month.6': 'ଜୁନ୍',
  'month.7': 'ଜୁଲାଇ',
  'month.8': 'ଅଗଷ୍ଟ',
  'month.9': 'ସେପ୍ଟେମ୍ବର',
  'month.10': 'ଅକ୍ଟୋବର',
  'month.11': 'ନଭେମ୍ବର',
  'month.12': 'ଡିସେମ୍ବର',

  'Summary Dashboard': 'ସାରାଂଶ ଡ୍ୟାଶବୋର୍ଡ',
  'Procurement Monitoring Dashboard': 'କ୍ରୟ ନିରୀକ୍ଷଣ ଡ୍ୟାଶବୋର୍ଡ',
  'Requisition Register': 'ଆବଶ୍ୟକତା ରେଜିଷ୍ଟର',
  'Procurement Case Register': 'କ୍ରୟ ମାମଲା ରେଜିଷ୍ଟର',
  'GeM Procurement': 'GeM କ୍ରୟ',
  'e-Tendering': 'ଇ-ଟେଣ୍ଡରିଂ',
  'Global Tender': 'ଗ୍ଲୋବାଲ ଟେଣ୍ଡର',
  'Local Purchase Committee': 'ସ୍ଥାନୀୟ କ୍ରୟ କମିଟି',
  'Open Market Procurement': 'ଖୋଲା ବଜାର କ୍ରୟ',
  'Tender/Bid Register': 'ଟେଣ୍ଡର/ବିଡ୍ ରେଜିଷ୍ଟର',
  'EMD Tracker/Register': 'EMD ଟ୍ରାକର/ରେଜିଷ୍ଟର',
  'Sample Register': 'ନମୁନା ରେଜିଷ୍ଟର',
  'Technical Evaluation': 'ପ୍ରାଯୁକ୍ତିକ ମୂଲ୍ୟାୟନ',
  'Financial Evaluation': 'ଆର୍ଥିକ ମୂଲ୍ୟାୟନ',
  'Purchase Order': 'କ୍ରୟ ଆଦେଶ',
  'Performance Security': 'କାର୍ଯ୍ୟଦକ୍ଷତା ସୁରକ୍ଷା',
  'Delivery/Acceptance': 'ଡେଲିଭରି/ଗ୍ରହଣ',
  'Payment Tracker': 'ପେମେଣ୍ଟ ଟ୍ରାକର',
  'Reports': 'ରିପୋର୍ଟ',
  'User Management': 'ବ୍ୟବହାରକାରୀ ପରିଚାଳନା',
  'Change Theme': 'ଥିମ୍ ପରିବର୍ତ୍ତନ',
  'Status': 'ସ୍ଥିତି',
  'Date': 'ତାରିଖ',
  'Quantity': 'ପରିମାଣ',
  'Estimated Cost': 'ଆନୁମାନିକ ଖର୍ଚ୍ଚ',
  'Budget Head': 'ବଜେଟ୍ ହେଡ୍',
  'Remarks': 'ଟିପ୍ପଣୀ',
  'Name of the Items': 'ଆଇଟମର ନାମ',
  'Items': 'ଆଇଟମଗୁଡ଼ିକ',
  'Sl. No.': 'କ୍ର. ସଂ.',
  'Serial No.': 'କ୍ରମିକ ସଂଖ୍ୟା',
  'Description': 'ବିବରଣୀ',
  'Type': 'ପ୍ରକାର',
  'Others': 'ଅନ୍ୟାନ୍ୟ',
  'Manual Procurement Case': 'ହସ୍ତଚାଳିତ କ୍ରୟ ମାମଲା',
  'Other Procurement Mode': 'ଅନ୍ୟ କ୍ରୟ ପଦ୍ଧତି',
  'Enter procurement case number or reference': 'କ୍ରୟ ମାମଲା ନମ୍ବର କିମ୍ବା ସନ୍ଦର୍ଭ ଲେଖନ୍ତୁ',
  'Enter procurement mode': 'କ୍ରୟ ପଦ୍ଧତି ଲେଖନ୍ତୁ',
  'Alphanumeric and special characters are allowed.': 'ଅକ୍ଷର, ସଂଖ୍ୟା ଏବଂ ବିଶେଷ ଚିହ୍ନ ବ୍ୟବହାର କରିପାରିବେ।',
  'Other Type': 'ଅନ୍ୟ ପ୍ରକାର',
  'Budget Head Name': 'ବଜେଟ୍ ହେଡ୍ ନାମ',
  'Enter item description': 'ଆଇଟମ ବିବରଣୀ ଲେଖନ୍ତୁ',
  'Enter item type': 'ଆଇଟମ ପ୍ରକାର ଲେଖନ୍ତୁ',
  'Enter budget head name': 'ବଜେଟ୍ ହେଡ୍ ନାମ ଲେଖନ୍ତୁ',
  'Unit': 'ଏକକ',
  'Action': 'କାର୍ଯ୍ୟ',
  'Tender Items': 'ଟେଣ୍ଡର ଆଇଟମ',
  'Sample Items': 'ନମୁନା ଆଇଟମ',
  'Make': 'ମେକ୍',
  'Model': 'ମଡେଲ୍',
  'Tender Number': 'ଟେଣ୍ଡର ସଂଖ୍ୟା',
  'Tender Date': 'ଟେଣ୍ଡର ତାରିଖ',
  'Bidder Name': 'ବିଡର ନାମ',
  'Name of the Bidder': 'ବିଡରର ନାମ',
  'Amount': 'ରାଶି',
  'Invoice Amount': 'ଇନଭଏସ୍ ରାଶି',
  'Paid Amount': 'ଦେୟ ରାଶି',
  'Payment Status': 'ପେମେଣ୍ଟ ସ୍ଥିତି',
  'Approval Status': 'ଅନୁମୋଦନ ସ୍ଥିତି',
  'Lifecycle Stage': 'ଜୀବନଚକ୍ର ପର୍ଯ୍ୟାୟ',
  'Mode of Procurement': 'କ୍ରୟ ପ୍ରକାର',
  'Procurement Mode': 'କ୍ରୟ ପ୍ରକାର',
  'Procurement Case': 'କ୍ରୟ ମାମଲା',
  'Linked Procurement Case': 'ସଂଯୁକ୍ତ କ୍ରୟ ମାମଲା',
  'Linked Requisition': 'ସଂଯୁକ୍ତ ଆବଶ୍ୟକତା',
  'Source Requisition': 'ଉତ୍ସ ଆବଶ୍ୟକତା',
  'Tender': 'ଟେଣ୍ଡର',
  'Evaluator': 'ମୂଲ୍ୟାୟନକାରୀ',
  'Score': 'ସ୍କୋର',
  'Result': 'ଫଳାଫଳ',
  'Rank': 'ର୍ୟାଙ୍କ',
  'Vendor Name': 'ବିକ୍ରେତାର ନାମ',
  'District': 'ଜିଲ୍ଲା',
  'Range': 'ରେଞ୍ଜ',
  'Designation': 'ପଦବୀ',
  'Name of the Person': 'ବ୍ୟକ୍ତିଙ୍କ ନାମ',
  'Fire Station / Establishment Name': 'ଫାୟାର ଷ୍ଟେସନ / ସ୍ଥାପନା ନାମ',
  'draft': 'ଖସଡ଼ା',
  'submitted': 'ଦାଖଲ',
  'in_progress': 'ଚାଲୁଛି',
  'approved': 'ଅନୁମୋଦିତ',
  'rejected': 'ଅସ୍ୱୀକୃତ',
  'completed': 'ସମ୍ପୂର୍ଣ୍ଣ',
  'cancelled': 'ବାତିଲ୍',
  'Mode Selection': 'ପ୍ରକାର ଚୟନ',
  'In Progress': 'ଚାଲୁଛି',
  'Approval Pending': 'ଅନୁମୋଦନ ବାକି',
  'Awarded': 'ପ୍ରଦାନ ହୋଇଛି',
  'Contracted': 'ଚୁକ୍ତି ହୋଇଛି',
  'Delivered': 'ଡେଲିଭର୍ ହୋଇଛି',
  'Closed': 'ବନ୍ଦ',
  'Cancelled': 'ବାତିଲ୍',
  'Pending': 'ବାକି',
  'Held': 'ଧରି ରଖାଯାଇଛି',
  'Fire Station Submission': 'ଫାୟାର ଷ୍ଟେସନ ଦାଖଲ',
  'District Scrutiny (AFO)': 'ଜିଲ୍ଲା ଯାଞ୍ଚ (AFO)',
  'Circle Consolidation (DFO)': 'ସର୍କଲ ସଂକଳନ (DFO)',
  'Range Scrutiny (FO)': 'ରେଞ୍ଜ ଯାଞ୍ଚ (FO)',
  'Directorate Provisioning Review': 'ନିର୍ଦ୍ଦେଶାଳୟ ପ୍ରାବଧାନ ସମୀକ୍ଷା',
  'Pending CFO': 'CFO ପାଖରେ ବାକି',
  'Pending IG': 'IG ପାଖରେ ବାକି',
  'Pending DG': 'DG ପାଖରେ ବାକି',
  'Approved': 'ଅନୁମୋଦିତ'
  ,
  'Requisition Dashboard': 'ଆବଶ୍ୟକତା ଡ୍ୟାଶବୋର୍ଡ',
  'Procurement Dashboard': 'କ୍ରୟ ଡ୍ୟାଶବୋର୍ଡ',
  'Compliance Dashboard': 'ଅନୁପାଳନ ଡ୍ୟାଶବୋର୍ଡ',
  'Approval Queue': 'ଅନୁମୋଦନ ଧାରା',
  'Mode-wise Procurement Cases': 'ପ୍ରକାର ଅନୁଯାୟୀ କ୍ରୟ ମାମଲା',
  'EMD, PBG and Contract Alerts': 'EMD, PBG ଏବଂ ଚୁକ୍ତି ସତର୍କତା',
  'Total Records': 'ମୋଟ ରେକର୍ଡ',
  'Total Value': 'ମୋଟ ମୂଲ୍ୟ',
  'Average Value': 'ସର୍ବମାନ ମୂଲ୍ୟ',
  'Summary Report': 'ସାରାଂଶ ରିପୋର୍ଟ',
  'Module-wise counts, status and values': 'ମଡ୍ୟୁଲ ଅନୁଯାୟୀ ଗଣନା, ସ୍ଥିତି ଏବଂ ମୂଲ୍ୟ',
  'Establishment-wise Record': 'ସ୍ଥାପନା ଅନୁଯାୟୀ ରେକର୍ଡ',
  'Requisition distribution by establishment': 'ସ୍ଥାପନା ଅନୁଯାୟୀ ଆବଶ୍ୟକତା ବିତରଣ',
  'Monthly Report': 'ମାସିକ ରିପୋର୍ଟ',
  'Month-wise movement within a year': 'ବର୍ଷ ମଧ୍ୟରେ ମାସ ଅନୁଯାୟୀ ଗତିବିଧି',
  'Yearly Report': 'ବାର୍ଷିକ ରିପୋର୍ଟ',
  'Year-on-year procurement totals': 'ବର୍ଷ ଅନୁଯାୟୀ କ୍ରୟ ସମୁଦାୟ',
  'GeM Procurement Register': 'GeM କ୍ରୟ ରେଜିଷ୍ଟର',
  'GeM bids, contracts and order values': 'GeM ବିଡ୍, ଚୁକ୍ତି ଏବଂ ଆଦେଶ ମୂଲ୍ୟ',
  'GeM Order Status Report': 'GeM ଆଦେଶ ସ୍ଥିତି ରିପୋର୍ଟ',
  'Delivery and payment status for GeM orders': 'GeM ଆଦେଶ ପାଇଁ ଡେଲିଭରି ଏବଂ ପେମେଣ୍ଟ ସ୍ଥିତି',
  'e-Tender Register': 'ଇ-ଟେଣ୍ଡର ରେଜିଷ୍ଟର',
  'Odisha e-Procurement tender lifecycle': 'ଓଡ଼ିଶା ଇ-ପ୍ରକ୍ୟୁରମେଣ୍ଟ ଟେଣ୍ଡର ଜୀବନଚକ୍ର',
  'Technical Evaluation Status': 'ପ୍ରାଯୁକ୍ତିକ ମୂଲ୍ୟାୟନ ସ୍ଥିତି',
  'Technical scrutiny status for e-Tenders': 'ଇ-ଟେଣ୍ଡର ପାଇଁ ପ୍ରାଯୁକ୍ତିକ ଯାଞ୍ଚ ସ୍ଥିତି',
  'Financial Evaluation Status': 'ଆର୍ଥିକ ମୂଲ୍ୟାୟନ ସ୍ଥିତି',
  'Financial evaluation and award status': 'ଆର୍ଥିକ ମୂଲ୍ୟାୟନ ଏବଂ ପ୍ରଦାନ ସ୍ଥିତି',
  'Global Tender Register': 'ଗ୍ଲୋବାଲ ଟେଣ୍ଡର ରେଜିଷ୍ଟର',
  'International bidding cases': 'ଆନ୍ତର୍ଜାତୀୟ ବିଡିଂ ମାମଲା',
  'Foreign Vendor Procurement': 'ବିଦେଶୀ ବିକ୍ରେତା କ୍ରୟ',
  'Foreign currency and INR procurement values': 'ବିଦେଶୀ ମୁଦ୍ରା ଏବଂ INR କ୍ରୟ ମୂଲ୍ୟ',
  'LPC Register': 'LPC ରେଜିଷ୍ଟର',
  'Local Purchase Committee cases': 'ସ୍ଥାନୀୟ କ୍ରୟ କମିଟି ମାମଲା',
  'LPC Recommendation Report': 'LPC ସୁପାରିଶ ରିପୋର୍ଟ',
  'Committee recommendations and comparative statements': 'କମିଟି ସୁପାରିଶ ଏବଂ ତୁଳନାତ୍ମକ ବିବୃତ୍ତି',
  'Open Market Register': 'ଖୋଲା ବଜାର ରେଜିଷ୍ଟର',
  'Open market procurement cases': 'ଖୋଲା ବଜାର କ୍ରୟ ମାମଲା',
  'Open Market Justification': 'ଖୋଲା ବଜାର ଯୁକ୍ତିସଙ୍ଗତତା',
  'Justification and market survey details': 'ଯୁକ୍ତିସଙ୍ଗତତା ଏବଂ ବଜାର ସର୍ଭେ ବିବରଣୀ',
  'EMD Register': 'EMD ରେଜିଷ୍ଟର',
  'EMD instruments and refund status': 'EMD ଯନ୍ତ୍ର ଏବଂ ରିଫଣ୍ଡ ସ୍ଥିତି',
  'EMD Pending Refund': 'EMD ରିଫଣ୍ଡ ବାକି',
  'EMDs pending return or refund': 'ଫେରତ କିମ୍ବା ରିଫଣ୍ଡ ବାକି ଥିବା EMD',
  'EMD Forfeiture Register': 'EMD ଜବତ ରେଜିଷ୍ଟର',
  'Forfeited EMD records': 'ଜବତ EMD ରେକର୍ଡ',
  'Performance Security Register': 'କାର୍ଯ୍ୟଦକ୍ଷତା ସୁରକ୍ଷା ରେଜିଷ୍ଟର',
  'PBG and security instruments': 'PBG ଏବଂ ସୁରକ୍ଷା ଯନ୍ତ୍ର',
  'PBG Expiry Alert': 'PBG ସମାପ୍ତି ସତର୍କତା',
  'Performance securities by expiry date': 'ସମାପ୍ତି ତାରିଖ ଅନୁଯାୟୀ କାର୍ଯ୍ୟଦକ୍ଷତା ସୁରକ୍ଷା',
  'Contract Expiry Alert': 'ଚୁକ୍ତି ସମାପ୍ତି ସତର୍କତା',
  'Purchase orders near completion': 'ସମାପ୍ତି ନିକଟରେ ଥିବା କ୍ରୟ ଆଦେଶ',
  'Budget Head-wise Expenditure': 'ବଜେଟ୍ ହେଡ୍ ଅନୁଯାୟୀ ବ୍ୟୟ',
  'Expenditure against budget heads': 'ବଜେଟ୍ ହେଡ୍ ବିପରୀତ ବ୍ୟୟ',
  'Procurement Value Analysis': 'କ୍ରୟ ମୂଲ୍ୟ ବିଶ୍ଳେଷଣ',
  'Approved value by procurement mode': 'କ୍ରୟ ପ୍ରକାର ଅନୁଯାୟୀ ଅନୁମୋଦିତ ମୂଲ୍ୟ',
  'Vendor-wise Procurement Value': 'ବିକ୍ରେତା ଅନୁଯାୟୀ କ୍ରୟ ମୂଲ୍ୟ',
  'Purchase value by vendor': 'ବିକ୍ରେତା ଅନୁଯାୟୀ କ୍ରୟ ମୂଲ୍ୟ',
  'Financial Year-wise Summary': 'ଆର୍ଥିକ ବର୍ଷ ଅନୁଯାୟୀ ସାରାଂଶ',
  'Financial year procurement movement': 'ଆର୍ଥିକ ବର୍ଷ କ୍ରୟ ଗତିବିଧି',
  'District-wise Procurement Summary': 'ଜିଲ୍ଲା ଅନୁଯାୟୀ କ୍ରୟ ସାରାଂଶ',
  'Procurement grouped by district': 'ଜିଲ୍ଲା ଅନୁଯାୟୀ ଗୋଷ୍ଠୀକୃତ କ୍ରୟ',
  'Circle-wise Procurement Summary': 'ସର୍କଲ ଅନୁଯାୟୀ କ୍ରୟ ସାରାଂଶ',
  'Procurement grouped by circle or establishment': 'ସର୍କଲ କିମ୍ବା ସ୍ଥାପନା ଅନୁଯାୟୀ କ୍ରୟ',
  'Range-wise Procurement Summary': 'ରେଞ୍ଜ ଅନୁଯାୟୀ କ୍ରୟ ସାରାଂଶ',
  'Procurement grouped by range': 'ରେଞ୍ଜ ଅନୁଯାୟୀ ଗୋଷ୍ଠୀକୃତ କ୍ରୟ',
  'Directorate Procurement Dashboard': 'ନିର୍ଦ୍ଦେଶାଳୟ କ୍ରୟ ଡ୍ୟାଶବୋର୍ଡ',
  'Directorate level procurement case status': 'ନିର୍ଦ୍ଦେଶାଳୟ ସ୍ତରର କ୍ରୟ ମାମଲା ସ୍ଥିତି',
  'Procurement Cycle Time Analysis': 'କ୍ରୟ ଚକ୍ର ସମୟ ବିଶ୍ଳେଷଣ',
  'Mode selection and sanction movement': 'ପ୍ରକାର ଚୟନ ଏବଂ ଅନୁମୋଦନ ଗତିବିଧି',
  'Procurement Aging Analysis': 'କ୍ରୟ ଏଜିଂ ବିଶ୍ଳେଷଣ',
  'Open procurement case aging': 'ଖୋଲା କ୍ରୟ ମାମଲାର ଏଜିଂ',
  'Top Vendors Report': 'ଶୀର୍ଷ ବିକ୍ରେତା ରିପୋର୍ଟ',
  'Vendor value and order status': 'ବିକ୍ରେତା ମୂଲ୍ୟ ଏବଂ ଆଦେଶ ସ୍ଥିତି',
  'Asset Procurement & Distribution': 'ସମ୍ପତ୍ତି କ୍ରୟ ଏବଂ ବିତରଣ',
  'Assets/items procured and distributed': 'କ୍ରୟ ଏବଂ ବିତରଣ ହୋଇଥିବା ସମ୍ପତ୍ତି/ଆଇଟମ',
  'Civic Blue': 'ସିଭିକ୍ ବ୍ଲୁ',
  'Clean government office theme with blue, teal, and amber accents.': 'ନୀଳ, ଟିଲ୍ ଏବଂ ଆମ୍ବର ଆକ୍ସେଣ୍ଟ ସହ ସରଳ ସରକାରୀ କାର୍ଯ୍ୟାଳୟ ଥିମ୍।',
  'OFS Classic': 'OFS କ୍ଲାସିକ୍',
  'Original fire service palette with warm red and gold tones.': 'ଉଷ୍ମ ଲାଲ୍ ଏବଂ ସୁନାର ଟୋନ୍ ସହ ମୂଳ ଅଗ୍ନିଶମ ସେବା ପ୍ୟାଲେଟ୍।',
  'Forest Ledger': 'ଫରେଷ୍ଟ ଲେଜର୍',
  'Calm green procurement desk theme for long register work.': 'ଦୀର୍ଘ ରେଜିଷ୍ଟର କାମ ପାଇଁ ଶାନ୍ତ ସବୁଜ କ୍ରୟ ଡେସ୍କ ଥିମ୍।',
  'Graphite': 'ଗ୍ରାଫାଇଟ୍',
  'Neutral charcoal theme with focused blue highlights.': 'ନୀଳ ହାଇଲାଇଟ୍ ସହ ନ୍ୟୁଟ୍ରାଲ୍ ଚାରକୋଲ୍ ଥିମ୍।',
  'Admin': 'ଆଡମିନ୍',
  'Procurement Officer': 'କ୍ରୟ ଅଧିକାରୀ',
  'Finance': 'ଅର୍ଥ',
  'Viewer': 'ଦର୍ଶକ',
  'admin': 'ଆଡମିନ୍',
  'procurement_officer': 'କ୍ରୟ ଅଧିକାରୀ',
  'evaluator': 'ମୂଲ୍ୟାୟନକାରୀ',
  'finance': 'ଅର୍ଥ',
  'viewer': 'ଦର୍ଶକ'
  ,
  'Incorrect username or password': 'ବ୍ୟବହାରକାରୀ ନାମ କିମ୍ବା ପାସୱାର୍ଡ ଭୁଲ।',
  'Inactive user': 'ବ୍ୟବହାରକାରୀ ସକ୍ରିୟ ନୁହେଁ।',
  'Username already exists': 'ଏହି ବ୍ୟବହାରକାରୀ ନାମ ପୂର୍ବରୁ ଅଛି।',
  'User not found': 'ବ୍ୟବହାରକାରୀ ମିଳିଲା ନାହିଁ।',
  'Record not found': 'ରେକର୍ଡ ମିଳିଲା ନାହିଁ।',
  'Unknown procurement stage': 'ଅଜଣା କ୍ରୟ ପର୍ଯ୍ୟାୟ।',
  'Administrative Approval Quantity cannot be higher than Requisition quantity.': 'ପ୍ରଶାସନିକ ଅନୁମୋଦନ ପରିମାଣ ଆବଶ୍ୟକତା ପରିମାଣଠାରୁ ଅଧିକ ହୋଇପାରିବ ନାହିଁ।',
  'Procurement mode must be one of GEM, E_TENDER, GLOBAL_TENDER, LPC, or OPEN_MARKET.': 'କ୍ରୟ ପ୍ରକାର GEM, E_TENDER, GLOBAL_TENDER, LPC କିମ୍ବା OPEN_MARKET ମଧ୍ୟରୁ ଗୋଟିଏ ହେବା ଆବଶ୍ୟକ।',
  'Record could not be saved because it conflicts with existing data.': 'ପୂର୍ବରୁ ଥିବା ତଥ୍ୟ ସହ ବିରୋଧ ଥିବାରୁ ରେକର୍ଡ ସଞ୍ଚୟ ହୋଇପାରିଲା ନାହିଁ।'
  ,
  'Demand No': 'ଡିମାଣ୍ଡ ସଂଖ୍ୟା',
  'Department': 'ବିଭାଗ',
  'Item Description': 'ଆଇଟମ ବିବରଣୀ',
  'Estimated Value': 'ଆନୁମାନିକ ମୂଲ୍ୟ',
  'Required By': 'ଆବଶ୍ୟକ ତାରିଖ',
  'Requisition No': 'ଆବଶ୍ୟକତା ସଂଖ୍ୟା',
  'Letter No. / Requisition No.': 'ଚିଠି ସଂଖ୍ୟା / ଆବଶ୍ୟକତା ସଂଖ୍ୟା',
  'Condemnable': 'ଅଚଳ ଘୋଷଣାଯୋଗ୍ୟ',
  'Not Condemnable': 'ଅଚଳ ଘୋଷଣାଯୋଗ୍ୟ ନୁହେଁ',
  'Requisition Received From': 'ଆବଶ୍ୟକତା ଗ୍ରହଣ ହୋଇଛି',
  'Administrative Approval Quantity': 'ପ୍ରଶାସନିକ ଅନୁମୋଦନ ପରିମାଣ',
  'Administrative Approval Date': 'ପ୍ରଶାସନିକ ଅନୁମୋଦନ ତାରିଖ',
  'Procurement Case No': 'କ୍ରୟ ମାମଲା ସଂଖ୍ୟା',
  'Approved Quantity': 'ଅନୁମୋଦିତ ପରିମାଣ',
  'Approved Estimated Cost': 'ଅନୁମୋଦିତ ଆନୁମାନିକ ଖର୍ଚ୍ଚ',
  'Case Status': 'ମାମଲା ସ୍ଥିତି',
  'Mode Selection Date': 'ପ୍ରକାର ଚୟନ ତାରିଖ',
  'Mode Selected By': 'ପ୍ରକାର ଚୟନକାରୀ',
  'EMD Applicable': 'EMD ଲାଗୁ',
  'PBG Applicable': 'PBG ଲାଗୁ',
  'File No': 'ଫାଇଲ୍ ସଂଖ୍ୟା',
  'Sanction No': 'ମଞ୍ଜୁରି ସଂଖ୍ୟା',
  'Sanction Date': 'ମଞ୍ଜୁରି ତାରିଖ',
  'Approving Authority': 'ଅନୁମୋଦନ କର୍ତ୍ତୃପକ୍ଷ',
  'GeM Procurement Type': 'GeM କ୍ରୟ ପ୍ରକାର',
  'GeM Bid No': 'GeM ବିଡ୍ ସଂଖ୍ୟା',
  'GeM Bid Date': 'GeM ବିଡ୍ ତାରିଖ',
  'GeM Contract No': 'GeM ଚୁକ୍ତି ସଂଖ୍ୟା',
  'GeM Contract Date': 'GeM ଚୁକ୍ତି ତାରିଖ',
  'GeM Order Value': 'GeM ଆଦେଶ ମୂଲ୍ୟ',
  'Vendor ID': 'ବିକ୍ରେତା ID',
  'Delivery Status': 'ଡେଲିଭରି ସ୍ଥିତି',
  'Tender Reference No': 'ଟେଣ୍ଡର ରେଫରେନ୍ସ ସଂଖ୍ୟା',
  'Tender Publication Date': 'ଟେଣ୍ଡର ପ୍ରକାଶନ ତାରିଖ',
  'Pre-Bid Meeting Date': 'ପ୍ରି-ବିଡ୍ ବୈଠକ ତାରିଖ',
  'Bid Submission End Date': 'ବିଡ୍ ଦାଖଲ ଶେଷ ତାରିଖ',
  'Technical Bid Opening Date': 'ପ୍ରାଯୁକ୍ତିକ ବିଡ୍ ଖୋଲିବା ତାରିଖ',
  'Financial Bid Opening Date': 'ଆର୍ଥିକ ବିଡ୍ ଖୋଲିବା ତାରିଖ',
  'L1 Vendor ID': 'L1 ବିକ୍ରେତା ID',
  'Award Approval Date': 'ପ୍ରଦାନ ଅନୁମୋଦନ ତାରିଖ',
  'LOA No': 'LOA ସଂଖ୍ୟା',
  'LOA Date': 'LOA ତାରିଖ',
  'Contract No': 'ଚୁକ୍ତି ସଂଖ୍ୟା',
  'Global Tender Ref No': 'ଗ୍ଲୋବାଲ ଟେଣ୍ଡର ରେଫରେନ୍ସ ସଂଖ୍ୟା',
  'Country of Vendor': 'ବିକ୍ରେତାର ଦେଶ',
  'Foreign Vendor Name': 'ବିଦେଶୀ ବିକ୍ରେତାର ନାମ',
  'Foreign Currency': 'ବିଦେଶୀ ମୁଦ୍ରା',
  'Exchange Rate': 'ବିନିମୟ ହାର',
  'Bid Value Foreign Currency': 'ବିଦେଶୀ ମୁଦ୍ରାରେ ବିଡ୍ ମୂଲ୍ୟ',
  'Bid Value INR': 'INR ରେ ବିଡ୍ ମୂଲ୍ୟ',
  'Commercial Evaluation Status': 'ବାଣିଜ୍ୟିକ ମୂଲ୍ୟାୟନ ସ୍ଥିତି',
  'Approval Date': 'ଅନୁମୋଦନ ତାରିଖ',
  'LPC Meeting No': 'LPC ବୈଠକ ସଂଖ୍ୟା',
  'LPC Meeting Date': 'LPC ବୈଠକ ତାରିଖ',
  'Committee Members': 'କମିଟି ସଦସ୍ୟ',
  'Quotation Count': 'କୋଟେସନ୍ ସଂଖ୍ୟା',
  'Lowest Vendor ID': 'ସବୁଠାରୁ କମ୍ ବିକ୍ରେତା ID',
  'Comparative Statement Path': 'ତୁଳନାତ୍ମକ ବିବୃତ୍ତି ପଥ',
  'Recommendation Date': 'ସୁପାରିଶ ତାରିଖ',
  'Procurement Justification': 'କ୍ରୟ ଯୁକ୍ତିସଙ୍ଗତତା',
  'Market Survey Date': 'ବଜାର ସର୍ଭେ ତାରିଖ',
  'Selected Vendor ID': 'ଚୟନିତ ବିକ୍ରେତା ID',
  'Bid Published Date': 'ବିଡ୍ ପ୍ରକାଶିତ ତାରିଖ',
  'Bid Closed Date': 'ବିଡ୍ ବନ୍ଦ ତାରିଖ',
  'No. of Technically Qualified Bidders': 'ପ୍ରାଯୁକ୍ତିକ ଯୋଗ୍ୟ ବିଡର ସଂଖ୍ୟା',
  'Product Demo Date': 'ପ୍ରଡକ୍ଟ ଡେମୋ ତାରିଖ',
  'Technical Evaluation Date': 'ପ୍ରାଯୁକ୍ତିକ ମୂଲ୍ୟାୟନ ତାରିଖ',
  'L1 Bidder Name (After RA/Negotiation)': 'L1 ବିଡର ନାମ (RA/ଆଲୋଚନା ପରେ)',
  'Contract Number': 'ଚୁକ୍ତି ସଂଖ୍ୟା',
  'Contract Date': 'ଚୁକ୍ତି ତାରିଖ',
  'EMD Unique ID': 'EMD ବିଶିଷ୍ଟ ID',
  'Form of EMD (BG/FDR)': 'EMD ରୂପ (BG/FDR)',
  'EMD No.': 'EMD ସଂଖ୍ୟା',
  'EMD Date': 'EMD ତାରିଖ',
  'EMD Amount': 'EMD ରାଶି',
  'Issuing Branch': 'ଜାରିକାରୀ ଶାଖା',
  'Bank Confirmation Date': 'ବ୍ୟାଙ୍କ ସୁନିଶ୍ଚିତକରଣ ତାରିଖ',
  'Expiry Date': 'ସମାପ୍ତି ତାରିଖ',
  'Returned Date': 'ଫେରତ ତାରିଖ',
  'Return Details': 'ଫେରତ ବିବରଣୀ',
  'Demonstration Date': 'ଡେମୋନ୍ଷ୍ଟ୍ରେସନ୍ ତାରିଖ',
  'Items / Quantity / Make / Model': 'ଆଇଟମ / ପରିମାଣ / ମେକ୍ / ମଡେଲ୍',
  'Receipt Date': 'ଗ୍ରହଣ ତାରିଖ',
  'Name of the Recipient': 'ଗ୍ରହୀତାଙ୍କ ନାମ',
  'Quoted Amount': 'ଉଦ୍ଧୃତ ରାଶି',
  'Negotiated Amount': 'ଆଲୋଚିତ ରାଶି',
  'PO No': 'PO ସଂଖ୍ୟା',
  'Order Date': 'ଆଦେଶ ତାରିଖ',
  'Process Initiate Date': 'ପ୍ରକ୍ରିୟା ଆରମ୍ଭ ତାରିଖ',
  'PO Value': 'PO ମୂଲ୍ୟ',
  'Form of Performance Security (BG/FDR)': 'କାର୍ଯ୍ୟଦକ୍ଷତା ସୁରକ୍ଷା ରୂପ (BG/FDR)',
  'Performance Security Number': 'କାର୍ଯ୍ୟଦକ୍ଷତା ସୁରକ୍ଷା ସଂଖ୍ୟା',
  'Performance Security Date': 'କାର୍ଯ୍ୟଦକ୍ଷତା ସୁରକ୍ଷା ତାରିଖ',
  'Warranty Period': 'ୱାରଣ୍ଟି ସମୟ',
  'Return Date': 'ଫେରତ ତାରିଖ',
  'Release Status': 'ରିଲିଜ୍ ସ୍ଥିତି',
  'Delivery Date': 'ଡେଲିଭରି ତାରିଖ',
  'Accepted Quantity': 'ଗ୍ରହୀତ ପରିମାଣ',
  'Acceptance Status': 'ଗ୍ରହଣ ସ୍ଥିତି',
  'Invoice No': 'ଇନଭଏସ୍ ସଂଖ୍ୟା',
  'Invoice Date': 'ଇନଭଏସ୍ ତାରିଖ'
};

export const TRANSLATIONS: Record<LanguageCode, TranslationTable> = { en, or };
